///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UserAuthorities } from '../../services/user/user-authorities';

@Component({
    selector: 'winde-user-role-badge',
    templateUrl: './user-role-badge.component.html',
    styles: [
        `
            span {
                max-width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        `
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GtthUserRoleBadgeComponent {
    @Input() userAuthority;
    userAuthorities = UserAuthorities;
}
